// QR Kiosk v2 — 50px chrome bar: text-built MACHINE·ID logo + LanguageChip +
// TierChip. Sticky at the top of the centered column. Ported from designer
// kiosk-shared.jsx `KChrome`. Tokens only; icons come from glyphs / inline SVG.
import React from "react";
import { LanguageChip } from "./LanguageChip";
import { TierChip } from "./TierChip";
import { KCHROME_H } from "../shared/kioskNav";

export function KChrome() {
  return (
    <div
      style={{
        height: KCHROME_H,
        flexShrink: 0,
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "0 14px",
        background: "var(--card)",
        borderBottom: "1px solid var(--border)",
      }}
    >
      <span
        style={{
          fontWeight: 800,
          fontSize: 15,
          letterSpacing: "0.02em",
          color: "var(--ink)",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        MACHINE
        <b
          style={{
            color: "var(--card)",
            background: "var(--ink)",
            padding: "2px 4px",
            borderRadius: 4,
            marginLeft: 1,
            fontSize: 12.5,
            fontWeight: 800,
          }}
        >
          ID
        </b>
      </span>
      <span style={{ flex: 1 }} />
      <LanguageChip />
      <TierChip />
    </div>
  );
}

export default KChrome;
